<div class="esn-empty-state">
  <esn-accent-hexagon />
  <div class="esn-empty-state__copy">
    <h2 class="esn-empty-state__title">{{ title() }}</h2>
    @if (text(); as body) {
      <p class="esn-empty-state__text">{{ body }}</p>
    }
  </div>
  <div class="esn-empty-state__actions">
    <ng-content />
  </div>
</div>
